<template>
  <a-modal
    v-model:visible="visible"
    title="替换字幕"
    :footer="null"
    :maskClosable="false"
    :destroyOnClose="false"
    width="480px"
  >
    <div class="replace-form">
      <!-- 查找 -->
      <div class="form-item">
        <div class="form-label">查找内容</div>
        <a-input
          v-model:value="findText"
          placeholder="请输入要查找的内容（必填）"
          allow-clear
        />
      </div>
      <!-- 替换为 -->
      <div class="form-item">
        <div class="form-label">替换为</div>
        <a-input
          v-model:value="replaceText"
          placeholder="留空表示替换为空字符串"
          allow-clear
        />
      </div>
      <!-- 替换范围 -->
      <div class="form-item">
        <div class="form-label">替换范围</div>
        <div class="checkbox-group">
          <a-checkbox v-model:checked="replaceTranslated">翻译字幕</a-checkbox>
          <a-checkbox v-model:checked="replaceOriginal">原版字幕</a-checkbox>
        </div>
      </div>
      <!-- 操作按钮 -->
      <div class="form-actions">
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" @click="onConfirm">确定替换</a-button>
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import { ref, defineExpose } from 'vue'

const emit = defineEmits(['confirm'])

const visible = ref(false)
const findText = ref('')
const replaceText = ref('')
const replaceTranslated = ref(true)
const replaceOriginal = ref(false)

function show() {
  findText.value = ''
  replaceText.value = ''
  replaceTranslated.value = true
  replaceOriginal.value = false
  visible.value = true
}

function onCancel() {
  visible.value = false
}

function onConfirm() {
  const findVal = (findText.value || '').trim()
  const replaceVal = replaceText.value ?? ''
  if (!findVal) {
    emit('confirm', { ok: false, reason: 'empty_find' })
    return
  }
  if (!replaceTranslated.value && !replaceOriginal.value) {
    emit('confirm', { ok: false, reason: 'empty_target' })
    return
  }
  emit('confirm', {
    ok: true,
    find: findVal,
    replace: replaceVal,
    replaceTranslated: replaceTranslated.value,
    replaceOriginal: replaceOriginal.value
  })
}

defineExpose({
  show
})
</script>

<style scoped>
.replace-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-label {
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.75);
}

.checkbox-group {
  display: flex;
  gap: 20px;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 14px;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
</style>


